(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urru-featured-tours"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.urru-featured a[href*="/products/"]');
    if (!link) return;
    const card = link.closest('.urru-featured__card');
    const cards = [...card.parentElement.children];
    document.dispatchEvent(new CustomEvent('urru:track', { detail: { name: 'urru_featured_click', product_handle: link.pathname.split('/products/')[1] || '', position: cards.indexOf(card) + 1 } }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urru-hero-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('urru-hero-player')) {
  customElements.define('urru-hero-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const link = this.querySelector('a');
      if (!link) return;
      const experienceAt = (time) => {
        if (time < 145) return 'xcaret-plus';
        if (time < 260) return 'xplor-day';
        if (time < 340) return 'xplor-fire';
        if (time >= 470 && time < 570) return 'xelha';
        return '';
      };
      const quoteDestination = (time) => {
        const destination = new URL(this.dataset.quoteUrl, window.location.origin);
        const experience = experienceAt(time);
        if (experience) destination.searchParams.set('experience', experience);
        destination.searchParams.set('ref', 'hero-video');
        return destination.toString();
      };
      const createQuoteHotspot = (timeProvider) => {
        const hotspot = document.createElement('span');
        hotspot.className = 'urru-hero__quote-hotspot';
        hotspot.setAttribute('role', 'link');
        hotspot.tabIndex = 0;
        hotspot.setAttribute('aria-label', 'Cotizar la experiencia que aparece en el video');
        let destination = '';
        const updateDestination = () => { destination = quoteDestination(Number(timeProvider()) || 0); };
        updateDestination();
        hotspot.addEventListener('pointerenter', updateDestination);
        hotspot.addEventListener('focus', updateDestination);
        hotspot.addEventListener('pointerdown', (event) => event.stopPropagation());
        hotspot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          updateDestination();
          window.location.assign(destination);
        });
        hotspot.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          event.stopPropagation();
          updateDestination();
          window.location.assign(destination);
        });
        return hotspot;
      };
      if (this.dataset.videoType === 'mp4') {
        const locale = (document.documentElement.lang || 'es').split('-')[0];
        const translations = {
          es: ['Descubre Grupo Xcaret', 'Parques, tours y experiencias de Grupo Xcaret.'],
          en: ['Discover Grupo Xcaret', 'Parks, tours and experiences by Grupo Xcaret.'],
          fr: ['Découvrez Grupo Xcaret', 'Parcs, excursions et expériences de Grupo Xcaret.'],
          it: ['Scopri Grupo Xcaret', 'Parchi, tour ed esperienze di Grupo Xcaret.'],
          de: ['Entdecke Grupo Xcaret', 'Parks, Touren und Erlebnisse von Grupo Xcaret.'],
          he: ['גלו את Grupo Xcaret', 'פארקים, סיורים וחוויות מבית Grupo Xcaret.']
        };
        const copy = translations[locale] || translations.es;
        link.setAttribute('aria-label', copy[0]);
        const label = link.querySelector('.urru-hero__video-label');
        const caption = this.closest('.urru-hero__media')?.querySelector('.urru-hero__caption');
        if (label) label.textContent = copy[0];
        if (caption) caption.textContent = copy[1];
      }
      this.dataset.ready = 'true'; if (sessionStorage.getItem('urruHeroVideoPlaying') === '1') setTimeout(() => link.click(), 0);
      link.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        if (this.dataset.videoType === 'mp4') {
          const source = this.dataset.videoUrl;
          if (!/^https:\/\//i.test(source)) return;
          event.preventDefault();
          const video = document.createElement('video');
          video.src = source;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          video.preload = 'metadata';
          video.setAttribute('aria-label', link.getAttribute('aria-label') || '');
          this.replaceChildren(video, createQuoteHotspot(() => video.currentTime));
          video.focus();
          return;
        }
        const id = this.dataset.videoId;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        sessionStorage.setItem('urruHeroVideoPlaying', '1'); const savedAt = Number(sessionStorage.getItem('urruHeroVideoTime') || 0); frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&enablejsapi=1' + (savedAt > 1 ? '&start=' + Math.floor(savedAt) : '');
        frame.title = link.getAttribute('aria-label');
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin'; const rememberProgress = () => { frame.contentWindow?.postMessage(JSON.stringify({ event: 'listening', id: 'urruHero' }), 'https://www.youtube-nocookie.com'); frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'getCurrentTime', args: [] }), 'https://www.youtube-nocookie.com'); }; const progressTimer = window.setInterval(rememberProgress, 1000); frame.addEventListener('load', rememberProgress, { once: true }); window.addEventListener('message', (message) => { if (message.source !== frame.contentWindow || message.origin !== 'https://www.youtube-nocookie.com') return; try { const payload = typeof message.data === 'string' ? JSON.parse(message.data) : message.data; const currentTime = Number(payload?.info?.currentTime); if (Number.isFinite(currentTime) && currentTime > 0) sessionStorage.setItem('urruHeroVideoTime', String(currentTime)); if (payload?.info?.playerState === 0) { sessionStorage.removeItem('urruHeroVideoTime'); sessionStorage.removeItem('urruHeroVideoPlaying'); } } catch (_) {} }); window.addEventListener('pagehide', () => window.clearInterval(progressTimer), { once: true });
        this.replaceChildren(frame, createQuoteHotspot(() => sessionStorage.getItem('urruHeroVideoTime')));
        frame.focus();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urru-tomorrow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urru-tomorrow')) customElements.define('urru-tomorrow', class extends HTMLElement {
    connectedCallback() {
      if (this.running) return;
      this.running=true;
      this.renderTours();
      this.poll=setInterval(()=>this.renderTours(),60000);
      this.visibility=()=>{if(!document.hidden)this.renderTours();};
      document.addEventListener('visibilitychange',this.visibility);
    }
    disconnectedCallback(){clearInterval(this.poll);document.removeEventListener('visibilitychange',this.visibility);this.running=false;}
    renderTours(){
      const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Cancun',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const value=type=>parts.find(p=>p.type===type).value;
      const tomorrow=new Date(`${value('year')}-${value('month')}-${value('day')}T12:00:00Z`);
      tomorrow.setUTCDate(tomorrow.getUTCDate()+1);
      const target=tomorrow.toISOString().slice(0,10);
      if(this.target===target)return;
      this.target=target;
      const day=String(tomorrow.getUTCDay());
      const formatted=new Intl.DateTimeFormat(document.documentElement.lang||'es',{dateStyle:'long',timeZone:'America/Cancun'}).format(tomorrow);
      const time=this.querySelector('[data-target-date]');time.dateTime=target;time.textContent=formatted;
      const grid=this.querySelector('[data-tomorrow-results]');grid.replaceChildren();
      let count=0;
      this.querySelectorAll('template[data-tour]').forEach(template=>{
        const split=value=>(value||'').split(',').map(s=>s.trim());
        if(!split(template.dataset.days).includes(day)||split(template.dataset.excluded).includes(target))return;
        const card=template.content.cloneNode(true);
        const request=card.querySelector('[data-request]');
        request.href='https://wa.me/529843195425?text='+encodeURIComponent(template.dataset.message.replace('URRU_DATE',target));
        request.addEventListener('click',()=>document.dispatchEvent(new CustomEvent('urru:track',{detail:{name:'urru_tomorrow_request',target_date:target}})));
        grid.append(card);count++;
      });
      this.querySelector('[data-empty]').hidden=count>0;
      this.hidden=false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urru-tour-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urru-tour-finder')) customElements.define('urru-tour-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const form = this.querySelector('form');
      const copy = this.querySelector('[data-copy]').dataset;
      const interests = [...form.querySelectorAll('[name="interests"]')];
      const results = this.querySelector('.urru-finder__results');
      const grid = this.querySelector('[data-results]');
      const track = (name, details = {}) => document.dispatchEvent(new CustomEvent('urru:track', { detail: { name, ...details } }));
      let started = false;
      form.addEventListener('change', () => { if (!started) { started = true; track('urru_finder_start'); } });
      const validateInterests = () => interests[0].setCustomValidity(interests.some(i => i.checked) ? '' : copy.pick);
      interests.forEach(i => i.addEventListener('change', validateInterests));
      validateInterests();
      form.addEventListener('submit', event => {
        event.preventDefault();
        validateInterests();
        if (!form.reportValidity()) return;
        const answers = new FormData(form);
        const chosen = answers.getAll('interests');
        const budget = Number(answers.get('budget')) * 100;
        const group = answers.get('group');
        const zone = answers.get('zone');
        const split = value => (value || '').split(',').map(x => x.trim());
        const ranked = [...this.querySelectorAll('template[data-tour]')].map((template, order) => {
          const d = template.dataset;
          const matches = chosen.filter(i => split(d.interests).includes(i));
          const price = Number(d.price);
          const score = matches.length * 10 + (split(d.groups).includes(group) ? 3 : 0) + (split(d.zones).includes(zone) ? 4 : 0);
          return {template, price, score, matches, order, within:price <= budget};
        }).filter(tour => tour.matches.length > 0)
          .sort((a,b) => b.matches.length-a.matches.length || Number(b.within)-Number(a.within) || b.score-a.score || a.price-b.price || a.order-b.order);
        const selected = ranked.slice(0,3);
        grid.replaceChildren();
        selected.forEach(tour => {
          const card = tour.template.content.cloneNode(true);
          const labels = tour.matches.map(i => interests.find(input => input.value === i).nextElementSibling.textContent.trim());
          card.querySelector('[data-match]').textContent = labels.length ? copy.matched+' '+labels.join(' · ') : copy.fallback;
          const badge = card.querySelector('[data-budget-state]');
          badge.textContent = tour.within ? copy.within : copy.over;
          badge.classList.toggle('is-over', !tour.within);
          card.querySelector('[data-zone-note]').textContent = zone !== 'playa' && split(tour.template.dataset.zones).length === 1 && split(tour.template.dataset.zones).includes('playa') ? copy.departure : copy.pickup;
          grid.append(card);
        });
        this.querySelector('[data-summary]').textContent = !selected.length ? copy.empty : selected.some(t => !t.within) ? copy.partial : '';
        track('urru_finder_complete', { group, zone, interests_count: chosen.length, budget_band: budget <= 150000 ? 'up_to_1500' : budget <= 250000 ? '1501_2500' : 'over_2500' });
        grid.querySelectorAll('a[href*="/products/"]').forEach((link, position) => link.addEventListener('click', () => track('urru_finder_result_click', { product_handle: link.pathname.split('/products/')[1] || '', position: position + 1 })));
        form.hidden = true;
        results.hidden = false;
        this.querySelector('[data-results-title]').focus();
      });
      this.querySelector('.urru-finder__edit').addEventListener('click', () => {
        results.hidden = true;
        form.hidden = false;
        form.querySelector('input').focus();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urru-trip-assistant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.urru-trip[data-section-id]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-dialog]');
    const storageKey = 'urru_trip_v1';
    const dayKey = 'urru_day_v1';
    const votedKey = 'urru_votes_v1';
    const groupStorageKey = 'urru_vote_group_v1';
    const deviceStorageKey = 'urru_vote_device_v1';
    const voteEndpoint = (root.dataset.voteEndpoint || '').replace(/\/$/, '');
    let remoteGroup = null;
    const itinerary = JSON.parse(root.querySelector('[data-itineraries]').textContent || '{}');
    const text = { save: root.dataset.saveLabel, saved: root.dataset.savedLabel, remove: root.dataset.removeLabel, vote: root.dataset.voteLabel, approximate: root.dataset.approximateLabel, from: root.dataset.fromLabel };
    const priceTemplate = root.querySelector('[data-price]').textContent;
    const priceLabel = (people) => people === 1 ? root.dataset.priceOneLabel : priceTemplate.replace(/\d+/, people);
    const memory = new Map();
    const read = (key, fallback) => { try { const value = localStorage.getItem(key); return value ? JSON.parse(value) : (memory.has(key) ? memory.get(key) : fallback); } catch (_) { return memory.has(key) ? memory.get(key) : fallback; } };
    const write = (key, value) => { memory.set(key, value); try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
    const track = (name, details = {}) => document.dispatchEvent(new CustomEvent('urru:track', { detail: { name, ...details } }));
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
    const handleFrom = (href) => { try { return new URL(href, location.href).pathname.match(/\/products\/([^/?#]+)/)?.[1] || ''; } catch (_) { return ''; } };
    const getTrip = () => read(storageKey, []);
    const setTrip = (items) => { write(storageKey, items); render(); decorate(); };
    const productData = async (handle) => {
      const saved = getTrip().find((item) => item.handle === handle);
      if (saved?.title && saved?.price != null) return saved;
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error('product');
        const product = await response.json();
        return { handle, title: product.title, url: product.url || `/products/${handle}`, image: product.featured_image || '', price: product.price || 0 };
      } catch (_) { return { handle, title: handle.replace(/-/g, ' '), url: `/products/${handle}`, image: '', price: 0 }; }
    };
    const add = async (handle) => {
      if (!handle) return;
      const items = getTrip();
      if (items.some((item) => item.handle === handle)) {
        setTrip(items.filter((item) => item.handle !== handle));
        track('urru_trip_remove', { product_handle: handle, saved_count: Math.max(0, items.length - 1) });
        return;
      }
      items.push(await productData(handle));
      setTrip(items);
      track('urru_trip_save', { product_handle: handle, saved_count: items.length });
    };
    const decorate = () => {
      document.querySelectorAll('#cart-drawer .urru-save-tour, cart-drawer-component .urru-save-tour, cart-items-component .urru-save-tour').forEach((button) => button.remove());
      const saved = new Set(getTrip().map((item) => item.handle));
      if (root.dataset.currentHandle && !document.querySelector(`.urru-save-tour[data-handle="${root.dataset.currentHandle}"]`)) {
        const heading = document.querySelector('main h1');
        if (heading) {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'urru-save-tour'; button.dataset.handle = root.dataset.currentHandle;
          button.innerHTML = `<span aria-hidden="true">♡</span><span>${text.save}</span>`;
          heading.insertAdjacentElement('afterend', button);
        }
      }
      document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        const handle = handleFrom(link.href);
        if (!handle || link.closest('.urru-trip, #cart-drawer, cart-drawer-component, cart-items-component') || link.closest('button') || link.querySelector('button')) return;
        const host = link.closest('product-card, .product-card, .card-product, .urru-related-card, article');
        if (!host || host.querySelector(`.urru-save-tour[data-handle="${handle}"]`)) return;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'urru-save-tour'; button.dataset.handle = handle;
        button.innerHTML = `<span aria-hidden="true">♡</span><span>${text.save}</span>`;
        host.append(button);
      });
      document.querySelectorAll('.urru-save-tour').forEach((button) => {
        const active = saved.has(button.dataset.handle);
        button.classList.toggle('is-saved', active);
        button.querySelector('span:last-child').textContent = active ? text.saved : text.save;
        button.querySelector('span:first-child').textContent = active ? '♥' : '♡';
      });
    };
    const deviceId = () => {
      let value = read(deviceStorageKey, '');
      if (!value) {
        value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
        write(deviceStorageKey, value);
      }
      return value;
    };
    const groupState = () => read(groupStorageKey, null);
    const groupRequest = async (path, options = {}) => {
      if (!voteEndpoint) throw new Error('vote endpoint');
      const state = groupState();
      const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
      if (state?.key) headers['X-URRU-Group-Key'] = state.key;
      const response = await fetch(`${voteEndpoint}${path}`, { ...options, headers });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || 'vote request');
      return payload;
    };
    const importSharedTours = async (items) => {
      const local = getTrip();
      for (const item of items || []) {
        if (local.some((saved) => saved.handle === item.handle)) continue;
        local.push(item.title ? item : await productData(item.handle));
      }
      setTrip(local);
      root.querySelector('[data-shared-intro]').hidden = false;
      dialog.showModal();
    };
    const parseShare = async () => {
      const params = new URLSearchParams(location.hash.startsWith('#') ? location.hash.slice(1) : '');
      const groupId = params.get('urru-group'); const groupKey = params.get('urru-key');
      if (voteEndpoint && groupId && groupKey) {
        write(groupStorageKey, { id: groupId, key: groupKey });
        try {
          const payload = await groupRequest(`/groups/${encodeURIComponent(groupId)}`);
          remoteGroup = payload.group;
          await importSharedTours(remoteGroup.tours);
          render();
          return;
        } catch (_) {
          write(groupStorageKey, null);
        }
      }
      const handles = (params.get('urru-trip') || '').split(',').filter(Boolean).slice(0, 12);
      if (!handles.length) return;
      await importSharedTours(await Promise.all(handles.map(productData)));
    };
    const votesFromHash = () => {
      const params = new URLSearchParams(location.hash.startsWith('#') ? location.hash.slice(1) : '');
      return Object.fromEntries((params.get('urru-votes') || '').split(',').filter(Boolean).map((pair) => { const [key, value] = pair.split(':'); return [key, Number(value) || 0]; }));
    };
    const getVotes = () => {
      if (remoteGroup?.totals) return remoteGroup.totals;
      const shared = votesFromHash(); const local = read('urru_group_votes_v1', {}); const merged = { ...shared };
      Object.keys(local).forEach((key) => { merged[key] = Math.max(merged[key] || 0, local[key] || 0); });
      return merged;
    };
    const winners = (items, votes) => [...items].sort((a, b) => (votes[b.handle] || 0) - (votes[a.handle] || 0)).slice(0, 2);
    const currentVotedKey = () => groupState()?.id ? `${votedKey}_${groupState().id}` : votedKey;
    const render = () => {
      const items = getTrip(); const votes = getVotes(); const voted = read(currentVotedKey(), []);
      root.querySelector('[data-count]').textContent = items.length;
      root.querySelector('[data-empty]').hidden = items.length > 0;
      root.querySelectorAll('[data-any-actions]').forEach((el) => { el.hidden = items.length === 0; });
      root.querySelector('[data-share]').hidden = items.length < 2;
      root.querySelector('[data-share-note]').hidden = items.length < 2;
      root.querySelector('[data-shared-intro]').hidden = items.length < 2;
      const list = root.querySelector('[data-list]'); list.textContent = '';
      items.forEach((item) => {
        const card = document.createElement('article'); card.className = 'urru-trip__card';
        card.innerHTML = `${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : '<span></span>'}<div><h3><a href="${item.url}">${item.title}</a></h3><p>${item.price ? `${text.from} ${money(item.price)}` : ''}</p><button class="urru-trip__remove" type="button">${text.remove}</button></div><button class="urru-trip__vote${voted.includes(item.handle) ? ' is-voted' : ''}" type="button" data-vote="${item.handle}">♥ ${votes[item.handle] || 0}<br>${text.vote}</button>`;
        card.querySelector('.urru-trip__remove').addEventListener('click', () => setTrip(items.filter((other) => other.handle !== item.handle)));
        card.querySelector('[data-vote]').addEventListener('click', () => vote(item.handle));
        list.append(card);
      });
      const group = root.querySelector('[data-group]'); group.hidden = items.length < 2;
      const top = winners(items, votes); root.querySelector('[data-winners]').textContent = top.map((item) => item.title).join(' + ');
      root.querySelector('[data-reserve]').disabled = !top[0]?.url;
      root.querySelector('[data-total]').hidden = true;
      root.querySelector('[data-price]').textContent = priceLabel(Math.max(1, Number(root.querySelector('[data-travelers]').value) || 1));
      decorate();
    };
    const vote = async (handle) => {
      const key = currentVotedKey(); const voted = read(key, []);
      const next = voted.includes(handle) ? voted.filter((item) => item !== handle) : [...voted, handle];
      const state = groupState();
      if (voteEndpoint && state?.id && state?.key) {
        try {
          const payload = await groupRequest(`/groups/${encodeURIComponent(state.id)}/votes`, { method: 'POST', body: JSON.stringify({ deviceId: deviceId(), selections: next }) });
          remoteGroup = payload.group; write(key, next); render();
          track('urru_group_vote', { product_handle: handle, selected: next.includes(handle) });
          return;
        } catch (_) { return; }
      }
      const votes = getVotes(); votes[handle] = Math.max(0, (votes[handle] || 0) + (next.includes(handle) ? 1 : -1));
      write('urru_group_votes_v1', votes); write(key, next); render();
    };
    const share = async () => {
      const items = getTrip(); if (items.length < 2) return;
      const url = new URL(location.origin + location.pathname);
      const params = new URLSearchParams();
      if (voteEndpoint) {
        try {
          const savedGroup = groupState();
          if (savedGroup?.id && savedGroup?.key) {
            const payload = await groupRequest(`/groups/${encodeURIComponent(savedGroup.id)}`);
            const sameTours = payload.group?.tours?.map((item) => item.handle).sort().join(',') === items.map((item) => item.handle).sort().join(',');
            if (sameTours) remoteGroup = payload.group;
          }
          if (!remoteGroup) {
            const payload = await groupRequest('/groups', { method: 'POST', body: JSON.stringify({ tours: items.map(({ handle, title, url: productUrl, image, price }) => ({ handle, title, url: productUrl, image, price })) }) });
            remoteGroup = payload.group;
            write(groupStorageKey, { id: remoteGroup.id, key: remoteGroup.key });
          }
          params.set('urru-group', remoteGroup.id); params.set('urru-key', remoteGroup.key);
        } catch (_) { return; }
      } else {
        const votes = getVotes();
        params.set('urru-trip', items.map((item) => item.handle).join(','));
        params.set('urru-votes', items.map((item) => `${item.handle}:${votes[item.handle] || 0}`).join(','));
      }
      url.hash = params.toString();
      const message = `${root.dataset.shareMessage} ${url}`;
      window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
      track('urru_trip_share', { saved_count: items.length });
    };
    const showPrice = () => {
      const people = Math.max(1, Number(root.querySelector('[data-travelers]').value) || 1);
      const top = winners(getTrip(), getVotes())[0];
      root.querySelector('[data-price]').textContent = priceLabel(people);
      const total = root.querySelector('[data-total]'); total.hidden = !top?.price;
      total.textContent = top?.price ? `${text.approximate}: ${money(top.price * people)} · ${top.title}` : '';
      if (!top?.price) total.textContent = '';
      track('urru_trip_price', { travelers: people, product_handle: top?.handle || '' });
    };
    const cartSnapshot = async () => {
      try {
        const response = await fetch('/cart.js'); if (!response.ok) return;
        const cart = await response.json(); const line = cart.items?.[0]; if (!line) return;
        const properties = line.properties || {};
        const pick = (...names) => names.map((name) => properties[name]).find(Boolean) || '';
        const adults = Number(pick('Adultos', 'Adults')) || 0; const children = Number(pick('Menores', 'Children')) || 0; const infants = Number(pick('Infantes', 'Infants')) || 0;
        write(dayKey, { handle: line.handle, title: line.product_title, date: pick('Fecha del tour', 'Fecha', 'Tour date'), people: adults + children + infants || line.quantity, pickup: pick('Hotel / pickup', 'Hotel o punto de recogida', 'Pickup'), reference: read(dayKey, {}).reference || '' });
        renderDay();
      } catch (_) {}
    };
    const renderDay = () => {
      const day = read(dayKey, null); const card = root.querySelector('[data-day-card]'); const empty = root.querySelector('[data-day-empty]');
      empty.hidden = Boolean(day); card.hidden = !day; if (!day) return;
      const info = itinerary[day.handle] || {};
      root.querySelector('[data-day-title]').textContent = day.date ? `${day.date}: ${day.title}` : day.title;
      root.querySelector('[data-day-date]').textContent = day.date || '—'; root.querySelector('[data-day-people]').textContent = day.people || '—';
      root.querySelector('[data-day-pickup]').textContent = day.pickup || root.dataset.pendingLabel; root.querySelector('[data-day-departure]').textContent = info.departure || root.dataset.pendingLabel;
      root.querySelector('[data-day-arrival]').textContent = info.arrival || root.dataset.pendingLabel; root.querySelector('[data-day-bring]').textContent = info.bring || root.dataset.bringDefault;
      root.querySelector('[data-day-instructions]').textContent = info.instructions || root.dataset.instructionsDefault;
      root.querySelector('[data-day-reference]').value = day.reference || '';
      const number = root.dataset.whatsapp.replace(/\D/g, ''); const help = `${root.dataset.helpMessage} ${day.title}${day.date ? ` · ${day.date}` : ''}${day.reference ? ` · ${day.reference}` : ''}`;
      root.querySelector('[data-help]').href = `https://wa.me/${number}?text=${encodeURIComponent(help)}`;
    };
    root.querySelector('[data-open]').addEventListener('click', () => { dialog.showModal(); track('urru_trip_open', { saved_count: getTrip().length }); });
    root.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    root.querySelectorAll('[data-tab]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-tab]').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
      root.querySelectorAll('[data-panel]').forEach((panel) => { const active = panel.dataset.panel === button.dataset.tab; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    }));
    root.querySelector('[data-share]').addEventListener('click', share); root.querySelector('[data-price]').addEventListener('click', showPrice);
    root.querySelector('[data-travelers]').addEventListener('input', (event) => {
      const people = Math.max(1, Number(event.target.value) || 1);
      root.querySelector('[data-price]').textContent = priceLabel(people);
      root.querySelector('[data-total]').hidden = true;
    });
    root.querySelector('[data-day-reference]').addEventListener('change', (event) => { const day = read(dayKey, {}); day.reference = event.target.value.trim(); write(dayKey, day); renderDay(); });
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.urru-save-tour');
      if (!button) return;
      event.preventDefault(); event.stopImmediatePropagation();
      add(button.dataset.handle);
    }, true);
    root.querySelector('[data-reserve]').addEventListener('click', () => {
      const top = winners(getTrip(), getVotes())[0];
      if (!top?.url) return;
      track('urru_trip_reserve', { product_handle: top.handle || '' });
      dialog.close();
      window.location.assign(new URL(top.url, location.origin).href);
    });
    document.addEventListener('click', (event) => { if (event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')) cartSnapshot(); }, true);
    render(); renderDay(); decorate(); cartSnapshot(); parseShare();
    [500, 1500, 3000].forEach((delay) => setTimeout(decorate, delay));
  })();

  } catch(e) { console.error(e); }
})();
})();
